import locales from "./locales/locales";
import router from './routes/routes'

export const ProjectsModule = {
	name: 'projects',
	routes: router,
	locales: locales,
}